<nz-modal
  nzTitle="Верификация deb-пакета"
  [(nzVisible)]="isVerificationModalVisible"
  [nzFooter]="null"
  [nzWidth]="700"
  [nzBodyStyle]="{ height: '900px', 'overflow-y': 'auto' }"
  (nzOnCancel)="closeVerificationModal()"
>
  <ng-container *nzModalContent>
    <div class="modal-header">Установить софт:</div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandInstall)"
    >
      <div class="copy-command-container" #commandInstall>
        apt install gpg debsigs -y
        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </div>
    </nz-card>
    <br />

    <div class="modal-header">Публичный ключ:</div>

    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandKey)"
    >
      <pre class="copy-command-container pre-line" #commandKey>
        -----BEGIN PGP PUBLIC KEY BLOCK-----

        {{ PUBLIC_KEY }}
        -----END PGP PUBLIC KEY BLOCK-----
        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </pre>
    </nz-card>
    <br />

    <div class="modal-header">
      Импортировать в систему (дальнейшие действия делать под root):
    </div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandImport)"
    >
      <div class="copy-command-container" #commandImport>
        gpg --import public.key
        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </div>
    </nz-card>
    <br />

    <div class="modal-header">Добавить ключ для debsigs в KEY_ID папку:</div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandAdd)"
    >
      <div class="copy-command-container" #commandAdd>
        <div>
          mkdir /usr/share/debsig/keyrings/8D5EA25E0F2776A5
          <br />
          <span class="nowrap">
            gpg --export 8D5EA25E0F2776A5 >
            /usr/share/debsig/keyrings/8D5EA25E0F2776A5/debsig.gpg</span
          >
        </div>

        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </div>
    </nz-card>
    <br />

    <div class="modal-header">Создать XML policy:</div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandCreate)"
    >
      <div class="copy-command-container" #commandCreate>
        sudo mkdir -p /etc/debsig/policies/8D5EA25E0F2776A5/

        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </div>
    </nz-card>
    <br />
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandHtml)"
    >
      <pre class="copy-command-container" #commandHtml>
cat &lt;&lt;EOF >>/etc/debsig/policies/8D5EA25E0F2776A5/sign.pol
&lt;?xml version="1.0"?>
&lt;!DOCTYPE Policy SYSTEM "https://www.debian.org/debsig/1.0/policy.dtd">
&lt;Policy xmlns="https://www.debian.org/debsig/1.0/">

  &lt;!-- This is mainly a sanity check, since our filename is that of the ID
      anyway. --&gt;
  &lt;Origin Name="Debsig" id="8D5EA25E0F2776A5" Description="Debsig testing"/>

  &lt;!-- This is required to match in order for this policy to be used. We
      reject the release Type, since we want a different rule set for
      that. --&gt;
   &lt;Selection>
    &lt;Required Type="origin" File="debsig.gpg" id="8D5EA25E0F2776A5"/>
  &lt;/Selection>

  &lt;!-- Once we decide to use this policy, this must pass in order to verify
      the package. --&gt;
  &lt;Verification MinOptional="0">
    &lt;Required Type="origin" File="debsig.gpg" id="8D5EA25E0F2776A5"/>
  &lt;/Verification>

&lt;/Policy>
EOF
        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </pre>
    </nz-card>
    <br />

    <div class="modal-header">Верификация, пример:</div>
    <nz-card
      [nzBodyStyle]="{
        background: '#fafafa',
        padding: '12px',
      }"
      (click)="copy(commandVerify)"
    >
      <div class="copy-command-container" #commandVerify>
        <span class="nowrap">
          debsig-verify --debug --verbose
          /tmp/Bfs.ApplicationHub.2024.11.19499-master.deb
        </span>

        <div class="copy-icon">
          <span nz-icon nzType="copy"></span>
        </div>
      </div>
    </nz-card>
  </ng-container>
</nz-modal>
